import {Nullable} from '@/app/common/util/Nullable';

interface ISidebarModule {
  sidebarMini: boolean,
  currentWidth: Nullable<number>
}

export default {
  namespaced: true,
  state: {sidebarMini: false, currentWidth: null},
  mutations: {
    setSidebarState(state: ISidebarModule, isMini: boolean) {
      state.sidebarMini = isMini;
    },
    setCurrentWidth(state: ISidebarModule, width: Nullable<number>) {
      state.currentWidth = width;
    },
  },
  getters: {
    getSidebarState: (data: ISidebarModule) => data.sidebarMini,
    getCurrentWidth: (data: ISidebarModule) => data.currentWidth,
  },
};
